export default {
  "Internal_Tools_B_Ejwk_Ynxz": "如果你不想使用{{brand_name}}生成的借记凭证，你可以自行上传这笔账单对应金额的借记通知单，平台会审核你上传的文件。",
  "Internal_Tools_B_VhXm_dBVV": "负责人签名",
  "Internal_Tools_3_HrdF_EKQU": "点击或拖入文件上传",
  "Internal_Tools_2_UVGE_CWXm": "请输入内容",
  "Internal_Tools_B_POgT_ZnaL": "商品ID",
  "Internal_Tools_B_BxVt_bJek": "总计",
  "Internal_Tools_3_BaNN_xmlP": "油站折扣（修改后）（{{currency_symbols}}）（值必须≥0.05）",
  "Internal_Tools_B_baJJ_iGYw": "确认完成后才可下载。",
  "Internal_Tools_B_fCsH_wsFp": "金额不合理",
  "Internal_Tools_B_woQh_xwQt": "请检查你的邮件地址是否是有效的。如果你需要更新邮箱地址，请联系管理员。",
  "Internal_Tools_2_lodd_TcJh": "原价总额",
  "Internal_Tools_B_uuAb_JWOl": "借记凭证信息",
  "Internal_Tools_B_ZNHx_trjR": "下载成功",
  "Internal_Tools_3_xIIl_Twme": "原价（{{currency_symbols}}）",
  "Internal_Tools_B_JlRY_rljm": "已通过",
  "GDriver_B_bBJO_VXlJ": "备注",
  "Internal_Tools_B_eiVg_xzja": "折扣类型",
  "Internal_Tools_2_vAhn_Teln": "点击或拖拽上传",
  "Internal_Tools_B_jTUw_mOnI": "总订单数",
  "GDriver_Rate_WnXP_FNfu": "负数代表合作费用大于平台补贴，但无需向平台支付，该数字将自动滚存至下一周期",
  "GDriver_B_eDuK_afie": "实时订单",
  "Internal_Tools_B_jySx_dhBR": "开票日期",
  "Internal_Tools_B_WWXN_VFkc": "{{variable_Name}}",
  "Internal_Tools_3_foFN_zztM": "确认上传折扣",
  "Internal_Tools_B_Tnvm_bEIP": "请输入油站折扣",
  "GDriver_0714_xgaM_KAUq": "更多",
  "Internal_Tools_B_xiIL_TLct": "请检查你的邮件垃圾箱。",
  "Internal_Tools_2_kwTR_iKCb": "下载二维码",
  "Internal_Tools_B_UaAZ_MOmJ": "银行账号",
  "Internal_Tools_2_tnYP_zmjj": "九月",
  "Internal_Tools_2_TJjb_Wvzj": "油站总折扣",
  "Internal_Tools_B_vlJT_UqQb": "城市",
  "Internal_Tools_B_qWSm_gsCg": "拒绝",
  "Internal_Tools_B_znDH_qMZE": "油站折扣不能超过商品原价",
  "Internal_Tools_B_GzUD_pXnf": "取消",
  "Internal_Tools_2_VunY_IMzD": "开始时间",
  "GDriver_B_fCnp_mBtP": "折扣后金额/升",
  "Internal_Tools_B_MtXg_YOBx": "请确认是否上架该商品？上架后，该商品将会在{{brand_name}}加油中对用户展示。",
  "Internal_Tools_2_yMpt_EUyT": "折扣后单价",
  "Internal_Tools_3_KtGv_jKWY": "导入折扣",
  "Internal_Tools_B_gPKb_TdEh": "保存失败",
  "GDriver_B_ObZo_cyru": "折扣后总额=折扣前总额-折扣总额",
  "Internal_Tools_B_VTCU_CeUB": "附件信息（可选）",
  "Internal_Tools_B_myuj_LLtq": "清除改动失败",
  "Internal_Tools_B_fhzE_VyPH": "确认",
  "Internal_Tools_B_IMVU_okmF": "保存",
  "GDriver_Rate_Mkpg_QdjY": "合作费用策略",
  "Internal_Tools_2_Ctnh_PCZG": "油站折扣",
  "Internal_Tools_B_smNl_fJqE": "{{brand_name}}已驳回",
  "GDriver_Rate_WEmP_UhBp": "当前页面展示关联订单，最远可追溯至三个月前",
  "Internal_Tools_B_rLLZ_yAjR": "保存成功",
  "GDriver_B_zaMj_EEIS": "订单状态",
  "Internal_Tools_2_fHjz_yFMU": "期望应收金额",
  "GDriver_B_eFya_eIeE": "原价",
  "Internal_Tools_B_zfQV_KiFx": "新的油站折扣比之前的折扣低。优惠力度的减少有可能会影响您油站的加油业务，请再次确认您填写的折扣是否正确。",
  "Internal_Tools_B_nRdi_lIgp": "商品原价",
  "Internal_Tools_B_aXSr_paiK": "调整",
  "Internal_Tools_B_FmOf_prqv": "银行名称",
  "Internal_Tools_B_jmKa_NsET": "提交确认",
  "GDriver_B_QzYe_htgo": "折扣前总额",
  "Internal_Tools_B_HXec_cozR": "折扣最近更新时间",
  "Internal_Tools_B_OZGf_eIJG": "已上架",
  "Internal_Tools_2_NMsR_VnbC": "燃料容量",
  "Internal_Tools_B_ewyj_jVhQ": "审批",
  "GDriver_0714_ZRFh_DHxb": "经营建议",
  "Internal_Tools_B_CieE_fzIW": "请选择",
  "Internal_Tools_2_RzTq_mRBg": "升数",
  "Internal_Tools_B_bgoN_mIid": "取消",
  "GDriver_0714_WCbg_WbRd": "用户评分",
  "Internal_Tools_B_DDWp_neUq": "{{brand_name}}结算金额",
  "Internal_Tools_B_tZsi_sztT": "基础信息",
  "Internal_Tools_B_hlMU_cWRx": "请确认是否下架此商品？下架后，该商品将不会在{{brand_name}}加油中对用户展示，请谨慎操作。",
  "Internal_Tools_2_KxKS_MqMX": "如果存在缺失订单，请点击这里。",
  "GDriver_0714_LFVn_YVQH": "此图展示过去60天1-4星评价的文字内容。",
  "Internal_Tools_B_eMoB_KRAm": "账单管理",
  "GDriver_0714_rSbl_WLiF": "数据待更新",
  "Internal_Tools_2_rCeC_qXKy": "你对金额的调整（{{bill_amount}}调整为{{bill_adjusted_amount}}）和上传的借记凭证被{{brand_name}}驳回了，请按照拒绝原因调整后再发起确认。",
  "Internal_Tools_3_eVmP_QNhY": "文件格式或表头错误，请重新上传",
  "Internal_Tools_B_sElL_adaZ": "公司名称",
  "GDriver_0714_BHFL_POgC": "得分",
  "GDriver_0714_rszt_qfQa": "1-4星评价中最多的标签",
  "GDriver_B_pcAA_HWoB": "计算中",
  "Internal_Tools_B_GaWI_nvTf": "{{Gas_Station_Name}}的{{Bill_Periods}}下的账单已经成功支付到你的账户上，金额为{{Bill_adjusted_amount}}，请确认。",
  "Internal_Tools_B_sFAV_iacx": "取消",
  "Internal_Tools_B_gans_zqgx": "请告诉我们为什么您选择下架商品，这有助于提升我们后续的服务和合作，谢谢！",
  "Internal_Tools_2_CeJk_uQAq": "请填写具体原因",
  "Internal_Tools_B_UilM_nfcx": "商品描述",
  "Internal_Tools_2_uwVq_MMJw": "请上传pdf、jpeg、jpg、png、xlsx格式的文件，大小不超过10MB",
  "Internal_Tools_B_vmUO_nwSd": "平台会调整加油用户的实际到手价，并承担折扣总额中多于油站折扣的这部分金额。",
  "Internal_Tools_2_MTMo_BaMI": "四月",
  "Internal_Tools_B_Hsqp_HMYm": "油站操作：",
  "Internal_Tools_B_gOmi_rvrr": "借记凭证",
  "Internal_Tools_B_KXEV_WsEc": "清空改动确认",
  "Internal_Tools_2_AdFu_XwYF": "直接退出后你对金额的调整将会被清除，是否要先保存你填写的内容再退出？",
  "Internal_Tools_B_jAUX_xIGC": "账单生成",
  "Internal_Tools_B_dgQy_EcYg": "提供给",
  "GDriver_Rate_Qnme_nHUC": "查看主账单",
  "Internal_Tools_2_RNZQ_cXCd": "你调整了{{num}}笔订单，调整后该账单额外结算金额为{{{adjustment_amount_orders}}}。",
  "GDriver_0714_uzWo_CJsO": "数据会每日更新",
  "Internal_Tools_B_LXmx_VUXh": "保存",
  "GDriver_Rate_kqZa_VLnH": "缺失订单",
  "Internal_Tools_3_IpMC_owwp": "请在服务时间内进线",
  "Internal_Tools_2_zdDd_lJmX": "输入金额需小于原价总额",
  "Internal_Tools_2_CnTD_lDFG": "没有数据",
  "Internal_Tools_B_ntHL_WvCO": "待确认",
  "Internal_Tools_B_BuUG_bfZR": "更多记录，请前往{折扣修改记录}",
  "Internal_Tools_2_ThRd_xnHT": "日",
  "Internal_Tools_2_lYFD_lpHi": "七月",
  "GDriver_Rate_gAPX_UqhX": "调整账单",
  "GDriver_0714_aNaU_XPkE": "过去15天",
  "Internal_Tools_2_nitD_IURE": "{{brand_name}}结算金额（调整后）",
  "Internal_Tools_B_cmzd_RyDx": "{{brand_name}}已支付",
  "Internal_Tools_B_HGyM_msoC": "操作人",
  "GDriver_B_FKZH_bmer": "商品名称",
  "GDriver_0714_Ufzq_DXfp": "每日更新",
  "Internal_Tools_2_uHFh_xZXJ": "订单数量",
  "GDriver_0714_BIkK_hHQF": "如果评分数量少于10条，评分将不向用户展示",
  "Internal_Tools_B_HMKF_pPXI": "自行上传借记凭证（可选）",
  "GDriver_B_AIST_uhIx": "总升数",
  "Internal_Tools_2_MwJt_SFwg": "备注",
  "Internal_Tools_B_MSqS_OLZh": "银行账户类型",
  "Internal_Tools_B_NorW_yQid": "{{brand_name}}反馈：调整申请被通过，请确认。",
  "Internal_Tools_2_qMwU_rvhb": "年",
  "GDriver_B_HAsu_pUhW": "已退款",
  "GDriver_B_fgYV_RobR": "折扣总额",
  "Internal_Tools_6_VKVq_bQAl": "提示",
  "Internal_Tools_B_cffn_cmkL": "下载账单明细",
  "GDriver_B_KVkL_ZHjF": "近7天",
  "Internal_Tools_B_elSJ_gIZG": "请上传pdf、jpeg、jpg、png格式的文件，大小不超过10MB",
  "Internal_Tools_2_hhOc_JJAW": "开始",
  "Internal_Tools_B_Fngc_WSSS": "油站优惠金额",
  "Internal_Tools_B_MBuz_Ymtp": "受益人姓名",
  "Internal_Tools_B_fDkS_eMyr": "操作人",
  "Internal_Tools_2_CrYy_JcNy": "使用手机扫描二维码",
  "GDriver_Rate_XEUc_iloC": "具体原因",
  "Internal_Tools_2_NLCP_rEFO": "移动端暂不支持审批功能，请在PC端操作",
  "Internal_Tools_2_pHZw_WxBd": "原价",
  "Internal_Tools_2_NgEj_cmVx": "秒",
  "Internal_Tools_2_kjSs_qYzP": "十月",
  "Internal_Tools_B_wUPq_CDsX": "银行账号：",
  "Internal_Tools_B_cclU_VMMo": "分行代码：",
  "GDriver_0714_cdPT_JKgL": "{{Rating}}({{Ratings_amount}})",
  "GDriver_Rate_Vgyp_nqsD": "订单数量",
  "Internal_Tools_2_BecI_qaZY": "结束",
  "Internal_Tools_B_MEDg_tikP": "基本信息",
  "Internal_Tools_2_kUxV_iMJC": "时间范围",
  "GDriver_B_Gxva_EpVj": "已完成",
  "Internal_Tools_2_JYyb_uJky": "退出登录",
  "Internal_Tools_B_HPAz_LoqE": "{{brand_name}}拒绝原因：{{variable_name}}",
  "Internal_Tools_B_iiVf_pSOO": "商品折扣调整详情",
  "GDriver_0714_qESd_UwOO": "评分数量",
  "Internal_Tools_B_PYRp_eEhi": "下载汇总对账单至你的邮箱",
  "GDriver_0714_rbBM_AgJg": "评价文字分布情况",
  "Internal_Tools_B_JKwQ_LMMp": "油站名称",
  "Internal_Tools_B_NrRO_hyjF": "城市-州",
  "Internal_Tools_B_eXuC_kQPR": "其他",
  "Internal_Tools_2_xUdt_pOMS": "燃料总容量",
  "Internal_Tools_B_Kcmr_GPux": "借记通知单不合规",
  "Internal_Tools_B_JBUV_TzRT": "请确认你是否要清空你的改动？清空后，你的调整记录将会被清除。",
  "Internal_Tools_B_cWRX_eefe": "账单金额",
  "Internal_Tools_B_ABGx_NgcF": "{{appendix}}",
  "Internal_Tools_3_hYrd_MHvK": "油品名称",
  "Internal_Tools_B_GZrT_BIFB": "总加油量（升）",
  "Internal_Tools_2_Xueq_krcz": "调整金额",
  "Internal_Tools_2_MhRN_FNUA": "液体燃料总升数",
  "Internal_Tools_2_ftnF_zZMU": "提交缺失订单",
  "GDriver_Rate_zQlW_UZCR": "本期金额",
  "Internal_Tools_B_hWZz_Swrm": "商品上架确认",
  "Internal_Tools_B_AeyK_bIak": "上架",
  "Internal_Tools_2_dgvn_fQpU": "请上传证明缺失订单的附件信息（.xlsx格式）",
  "Internal_Tools_3_GQxF_vack": "序号",
  "Internal_Tools_2_eBtC_jSgY": "结束时间",
  "GDriver_Rate_ujyz_RSOz": "缺失订单凭证",
  "Internal_Tools_B_wFVO_wUGQ": "手机号",
  "Internal_Tools_B_owWu_mwVa": "地址",
  "Internal_Tools_B_gYZs_ulOj": "最近更新时间",
  "Internal_Tools_B_VLNO_dwPV": "清空改动",
  "GDriver_0714_RTbN_YBVq": "{{Ratings_amount}}次评分",
  "Internal_Tools_B_yuff_FSjp": "取消",
  "Internal_Tools_B_mbwq_mnym": "{{Gas_Station_Name}}的{{Bill_Periods}}下的账单被{{brand_name}}审批拒绝了，请你前往{{brand_name}}加油确认。",
  "GDriver_Rate_vcNN_TOwL": "查看调整账单",
  "Internal_Tools_2_pACZ_Yzam": "最多支持调整{{num}}笔订单",
  "Internal_Tools_B_OBgN_mTrt": "下架",
  "Internal_Tools_B_lxML_RcGh": "下架原因",
  "Internal_Tools_2_XHWq_gRnu": "展示筛选条件",
  "Internal_Tools_2_oVai_vFAT": "{{brand_name}}结算金额",
  "GDriver_0714_yAyF_HyFt": "预览",
  "GDriver_Rate_LQtQ_IRrX": "期初金额",
  "Internal_Tools_2_VmKe_ukvq": "上传失败",
  "Internal_Tools_2_nHHF_Crlf": "你上传的借记凭证被{{brand_name}}驳回了，请按照拒绝原因调整后再发起确认。",
  "GDriver_0714_aCJL_sWTy": "评分数量/交易数量",
  "Internal_Tools_6_UFDK_QNkM": "确认要调整该油站的商品折扣吗？确认后，新的折扣将在油站上架时立即生效。",
  "Internal_Tools_2_XuZF_XpcU": "保存失败，请重试",
  "Internal_Tools_B_mIlH_Fkgh": "操作",
  "GDriver_B_mKhM_HPiy": "已取消",
  "Internal_Tools_B_nBFs_LXko": "如果信息不正确，请联系我们的销售{{sales_email}}修改。",
  "Internal_Tools_3_NlPw_QlkA": "高折扣",
  "Internal_Tools_B_btRf_kJeN": "所选条件下，加油订单总用户数，仅包含交易成功且未退单的用户",
  "Internal_Tools_B_Ajtt_rxuw": "银行名称：",
  "Internal_Tools_B_UOfz_hTHC": "查看",
  "Internal_Tools_B_qxrM_NiCE": "油站利润低，无法提供折扣",
  "Internal_Tools_B_ljFB_DAJr": "请先在下方输入油站折扣，然后点击上架按钮上架该商品。",
  "Internal_Tools_2_aRCX_mimf": "过滤了「取消」状态的订单",
  "Internal_Tools_B_AWqL_aCAL": "油站税号",
  "Internal_Tools_B_SxmG_vBav": "{{Gas_Station_Name}}的{{Bill_Periods}}账单已支付完成，请确认",
  "Internal_Tools_3_TwYi_hyXj": "是否调整金额",
  "Internal_Tools_B_eYAC_Clpm": "将金额从{{bill_amount}}调整为{{bill_adjusted_amount}}",
  "Internal_Tools_B_hORS_vRXF": "已下架",
  "Internal_Tools_B_biCt_AXoR": "只能上传pdf、jpeg、jpg、png格式的文件",
  "Internal_Tools_B_jDZP_kDzC": "油站折扣（调整前）",
  "Internal_Tools_B_Ghxe_pCWK": "有效",
  "Internal_Tools_2_TEGY_SONK": "每单位油站折扣",
  "Internal_Tools_B_MCil_Xcno": "类目",
  "Internal_Tools_B_bNIZ_hAGP": "请输入内容",
  "GDriver_B_apbe_dntZ": "油站名称",
  "Internal_Tools_B_Pmry_OGIf": "存款详情",
  "Internal_Tools_B_fZhR_srgn": "邮票",
  "Internal_Tools_3_SOIx_QzGa": "产品ID",
  "Internal_Tools_B_jpOd_zpOd": "发行/上传时间",
  "Internal_Tools_B_WuVw_UhVj": "借记凭证编号",
  "Internal_Tools_2_QPsS_gHnw": "取消",
  "GDriver_B_CkMV_hWxl": "本周",
  "GDriver_0714_sPhj_umcC": "用户评价细节",
  "Internal_Tools_B_Bkts_QgGl": "原因：{{reason}}",
  "Internal_Tools_B_TGdl_pQYC": "价格",
  "Internal_Tools_Ops_ZrXX_jLfJ": "一共{{order_quantity}}条",
  "Internal_Tools_B_Xddd_srny": "商品管理",
  "Internal_Tools_B_EAzs_ZGvU": "借记凭证",
  "Internal_Tools_3_fqmg_VDbw": "确认并上传",
  "GDriver_0714_CcNI_rsSC": "趋势分析",
  "Internal_Tools_B_XWSG_ifsw": "近期修改记录",
  "Internal_Tools_2_YBkJ_wHPL": "分钟",
  "GDriver_B_JAhN_lxfe": "折扣后总额",
  "Internal_Tools_B_ODcX_VDxG": "操作行为",
  "Internal_Tools_B_KTZQ_wBFq": "操作",
  "Internal_Tools_B_upRN_xOJy": "发行/上传方",
  "Internal_Tools_B_sCvg_DfYw": "账单周期",
  "Internal_Tools_B_JAZc_kfnw": "已拒绝",
  "Internal_Tools_B_EzRf_TXVr": "收不到邮件？",
  "Internal_Tools_B_elge_fQzz": "折扣调整确认",
  "Internal_Tools_B_wzLs_Zbqj": "所选条件下，加油订单总数，仅包含交易成功且未退单的订单",
  "GDriver_Rate_CNuf_gFsJ": "{{Platform_name}}合作费用",
  "GDriver_B_aseD_RLUl": "折扣码",
  "GDriver_B_JGKl_aMeG": "对账单",
  "Internal_Tools_6_Knpn_VdKB": "确认要展示该商品吗？确认后，商品将在油站上架时出现在{{brand_name}}加油中。",
  "Internal_Tools_2_SAIb_RpwU": "退出确认",
  "Finance_120version_All_XvPp": "全部",
  "GDriver_B_duAf_AXjt": "订单状态",
  "Internal_Tools_B_xfZE_YVTX": "{{Gas_Station_Name}}的{{Bill_Periods}}账单被{{brand_name}}审批拒绝，请确认",
  "Internal_Tools_B_HlmN_NmVE": "操作人邮箱",
  "GDriver_0714_YEsn_YJNV": "低分原因",
  "Internal_Tools_B_IdjN_nrct": "查看借记凭证",
  "Internal_Tools_B_PuzK_uAgA": "总折扣额",
  "Internal_Tools_B_rVeY_zhxF": "展示状态",
  "Internal_Tools_2_swod_ShaV": "十一月",
  "GDriver_Rate_qAKf_Tuxy": "结算金额",
  "GDriver_B_ypBU_eWTX": "总订单数量",
  "GDriver_B_voCc_twWK": "总用户数",
  "Internal_Tools_B_iuIG_bARf": "上架",
  "GDriver_B_hxEf_LgnF": "下载明细对账单",
  "Internal_Tools_B_maAi_LDaH": "确认",
  "Internal_Tools_B_yKrW_kCRv": "上传了借记凭证",
  "Internal_Tools_B_KcBD_VdDF": "总金额",
  "Internal_Tools_2_dhrn_UOGT": "折叠筛选条件",
  "Internal_Tools_B_eswZ_toaj": "请确认{{Gas_Station_Name}}的{{Bill_Periods}}账单",
  "Internal_Tools_4_Cwym_IJSI": "只能上传xlsx格式的文件",
  "Internal_Tools_2_ijcp_zTQW": "选择需调整金额的订单",
  "GDriver_Rate_OhXE_fUdr": "调整账单金额不能为负数，请修改后提交",
  "GDriver_B_BtUy_wEbU": "折扣总额",
  "Internal_Tools_4_FPhj_TwAr": "缺失订单附件信息",
  "Internal_Tools_B_ljtx_sZET": "商品下架确认",
  "GDriver_0714_yFdx_MsMQ": "好评",
  "Internal_Tools_B_scNd_qcZP": "完成",
  "Internal_Tools_B_xSlQ_mCao": "油站操作：{{variable_name}}",
  "Internal_Tools_3_kwOM_UZuX": "CNPJ",
  "GDriver_B_gltl_Hlxo": "油站名称",
  "Internal_Tools_B_zqAk_QFls": "最多只能上传1个文件",
  "Internal_Tools_2_ShWE_pqHC": "二月",
  "GDriver_0714_uhMc_pcOa": "近60天平均评分",
  "Internal_Tools_B_rSBU_GsMk": "银行付款",
  "Internal_Tools_B_fudE_UQpX": "请确认以下信息是否正确：",
  "Internal_Tools_B_bgHa_HtAx": "借记凭证历史",
  "GDriver_B_plYK_TBWO": "本月",
  "Internal_Tools_B_fEFC_wWrr": "账单状态",
  "GDriver_Rate_Ypvy_hqGY": "调整金额详情",
  "Internal_Tools_B_STXC_iwsY": "对账结算详情",
  "Internal_Tools_B_SPnJ_IQAe": "折扣管理",
  "GDriver_Rate_TJDL_AuGR": "关联账单列表",
  "Internal_Tools_2_Nqhz_aeKd": "当前您输入的账单金额和平台计算金额一致，请调整",
  "Internal_Tools_B_YhSM_fNbO": "税号:",
  "Internal_Tools_B_HmDv_lOyc": "上传成功",
  "Internal_Tools_B_BrTt_fcQx": "邮箱",
  "Internal_Tools_2_aHcj_MNUx": "气体燃料总体积",
  "Internal_Tools_B_dsMv_ZMMu": "新的油站折扣低于当前平台限制{{lower_limit}}，无法保存，请重新填写",
  "Internal_Tools_B_Nckm_MRzP": "供应商于{{time}}通过{{brand_name}}加油批准账单金额",
  "GDriver_B_SXwK_HWoB": "折扣前总额",
  "Internal_Tools_B_SahY_dqBb": "分行代码",
  "GDriver_B_kmNL_caEY": "加油时权益等级",
  "GDriver_B_gElW_SXdK": "订单总额",
  "Internal_Tools_B_WGhe_oKSS": "技术原因（网/电/RMS）",
  "Internal_Tools_B_qbYe_OgQa": "（{{brand_name}}计算）",
  "GDriver_B_mSPV_rbLY": "无权限，请联系系统管理员",
  "Internal_Tools_2_VPzK_SlSn": "五月",
  "Internal_Tools_2_tepY_hnPO": "每日{{time_start}}点至{{time_end}}点",
  "Internal_Tools_B_RxoO_bhVS": "发起油站折扣调整",
  "Internal_Tools_B_oGAj_HAts": "公司名称",
  "Internal_Tools_3_Okwr_nrog": "文件字段内容不正确，请下载文件查看错误原因",
  "Internal_Tools_B_kMWu_eiOM": "发送成功！",
  "Internal_Tools_Ops_vEHa_XFxU": "油站税号",
  "Internal_Tools_2_WOcZ_xmgT": "最多只能上传{{num}}个文件",
  "Internal_Tools_2_lSBW_srOU": "移动端暂不支持调整功能，请在PC端操作",
  "Internal_Tools_B_aBZb_ubgd": "商品详细名称",
  "Internal_Tools_B_fKyZ_jQjs": "折扣策略",
  "Internal_Tools_B_npwb_kifs": "如果你认为结算金额不正确，请点击{这里}去调整。",
  "Internal_Tools_B_vtbb_fwKe": "报表将发送到你的邮箱{{email_address}}。",
  "Internal_Tools_2_sVTx_zDXt": "油站应收金额-{{brand_name}}计算",
  "Internal_Tools_2_fLkn_zUya": "订单ID",
  "Internal_Tools_2_guyK_dNWP": "小时",
  "Internal_Tools_B_NrnD_CueJ": "上传文件大小应小于10MB",
  "Internal_Tools_2_DgKa_MWcm": "三月",
  "GDriver_0714_PlUK_vnZD": "交易数量",
  "Internal_Tools_B_roDY_yNHt": "清除改动成功",
  "Internal_Tools_B_LhVI_fQhq": "{{reason}}",
  "Internal_Tools_B_bNjt_LhgO": "商品名称",
  "Internal_Tools_B_klis_ZshW": "序号",
  "Internal_Tools_B_mVaF_oiOh": "因平台动态调整导致，不用产生支付。",
  "Internal_Tools_B_ljZA_uzFp": "客户ID",
  "Internal_Tools_2_ShSC_iPXl": "请上传文件",
  "Internal_Tools_B_qIkJ_vecB": "油站折扣额",
  "Internal_Tools_B_btLV_laDf": "审批历史",
  "Internal_Tools_2_dkIt_zOwG": "请补充缺失订单细节和期望{{brand_name}}单独结算的金额",
  "Internal_Tools_2_nsxA_ILyQ": "原始{{brand_name}}结算金额",
  "GDriver_B_OgXv_iCAL": "总数",
  "GDriver_B_GCvq_HEoF": "所选条件下，所有加油订单的升数总和",
  "Internal_Tools_B_sGXH_MbOC": "浏览",
  "Internal_Tools_2_GSUg_zEJU": "所选条件下，所有加油订单的液体类燃料的升数总和",
  "Internal_Tools_6_YUwb_Jftq": "商品未激活，不可修改",
  "Internal_Tools_3_qadq_ftID": "上传",
  "GDriver_Rate_kKDM_ZGLr": "问题订单",
  "GDriver_Rate_HfEU_JVUS": "服务费收取金额",
  "Internal_Tools_B_SCdD_gYeo": "已完成",
  "Internal_Tools_2_KVNS_Tidn": "一月",
  "GDriver_B_QGRk_fEQb": "下载汇总对账单",
  "Internal_Tools_B_alkr_LDhX": "固定比例折扣",
  "GDriver_B_gBCW_tqrc": "升数",
  "GDriver_B_uGTO_zzvy": "订单ID",
  "Internal_Tools_3_mbZw_bLfk": "第一步：基于筛选器下载模版",
  "Internal_Tools_B_Pfxu_ZJtI": "总计",
  "GDriver_Rate_lICZ_WYxq": "期末金额",
  "Internal_Tools_3_AkBo_IAuy": "取消",
  "GDriver_Rate_zCyR_AFnE": "该账单有调整，调整金额为{{adjusted_amount}}",
  "Internal_Tools_3_Famx_vWjX": "下载模版",
  "Internal_Tools_B_FGcc_qKjk": "取消",
  "Internal_Tools_B_Hiye_IHzm": "调整保存成功",
  "GDriver_B_puJr_wfVl": "账号已冻结，请联系系统管理员",
  "Internal_Tools_3_LLVV_gEyO": "油站折扣（修改前）（{{currency_symbols}}）",
  "Internal_Tools_2_AzpT_hWwx": "快捷选项",
  "Internal_Tools_3_HfRl_hfLy": "单次最多能上传1000条数据，请重新上传",
  "Internal_Tools_B_lKPj_Cfrr": "稍后你会在{{email_address}}收到你的报表。",
  "Internal_Tools_2_HapJ_nsTk": "八月",
  "Internal_Tools_2_jfyZ_sGtA": "十二月",
  "GDriver_0714_xdsg_usTU": "消极数量",
  "Internal_Tools_B_sYEO_YiqD": "通过",
  "Internal_Tools_B_dARX_ILFp": "折后价",
  "Internal_Tools_2_SKHb_kzAe": "商品名称",
  "Internal_Tools_B_HxGE_tKzV": "油站折扣（调整后）",
  "Internal_Tools_B_SOMA_BAzh": "折扣差异",
  "Internal_Tools_2_ZlCC_JcRC": "退出",
  "GDriver_0714_xaoL_Ugzz": "主要抱怨",
  "Internal_Tools_B_jbbQ_xdOx": "原因：{{reason}}",
  "GDriver_0714_SEEy_bOKG": "此图展示过去60天1-4星评价的标签。",
  "Internal_Tools_2_KOqv_srKp": "客服",
  "Internal_Tools_B_EnBP_ecCZ": "下载",
  "Internal_Tools_B_ooyJ_mlNY": "油站审核",
  "Internal_Tools_2_inUB_pEQn": "保存并退出",
  "Internal_Tools_2_nbUx_lwXP": "时间段",
  "GDriver_B_cjbU_mTvI": "油站折扣",
  "GDriver_0714_woUE_eHbz": "过去1个月",
  "GDriver_B_WUOr_ceCL": "数据中心",
  "Internal_Tools_B_Gzdd_AKbU": "油站调整金额",
  "GDriver_0714_rBxk_CstO": "有待提升",
  "Internal_Tools_B_MhcJ_rfQv": "商品折扣策略细节",
  "GDriver_Rate_loVu_PxhD": "查看关联账单",
  "Internal_Tools_B_ajlo_HnqP": "操作记录",
  "Internal_Tools_B_muPj_LeXe": "{{Brand_Name}}调整",
  "Internal_Tools_B_iLJS_uUwa": "商品上架成功",
  "Internal_Tools_B_bNEi_MfAw": "取消",
  "GDriver_0714_AnRO_kLNJ": "类别",
  "Internal_Tools_B_HOMP_Jysk": "商品下架成功",
  "Internal_Tools_B_HHxf_GgTF": "操作时间",
  "Internal_Tools_3_SBhz_EZXw": "油站名称",
  "Internal_Tools_2_oDlf_fVsf": "订单时间",
  "Internal_Tools_2_onjK_xaqD": "所选条件下，所有加油订单的气体类燃料的体积总和",
  "GDriver_Rate_FmgF_CgeQ": "1.固定字段值：根据筛选框中选择的条件生成。当你选择All时，字段值变为All；当你单选某一个条件时，列表中展示的是该选项对应的信息。",
  "Internal_Tools_2_eyOs_aAPw": "附件信息",
  "Internal_Tools_2_GaFz_pQZZ": "请挑选你认为存在有金额问题的订单，并输入期望金额。",
  "Internal_Tools_B_ceeV_dRMo": "付款周期",
  "Internal_Tools_B_upfK_Vzsc": "请输入",
  "Internal_Tools_2_mmuK_qILh": "液体类",
  "Internal_Tools_B_lWRy_tGTo": "日期",
  "Internal_Tools_B_zpbB_XOiB": "商品当前不可用",
  "Internal_Tools_2_IlQz_mEGK": "每单位原价",
  "Internal_Tools_B_Hfjm_aSzt": "取消",
  "Internal_Tools_B_ZWnL_NxIT": "描述",
  "Internal_Tools_B_SECS_XFym": "账单确认成功",
  "GDriver_Rate_VFLy_nWaE": "账单金额未发生变化，请调整后提交",
  "GDriver_0714_wkse_WUcd": "过去2个月",
  "Internal_Tools_B_iRuS_vbPU": "{{brand_name}}审批中",
  "Internal_Tools_B_lmzi_AdZe": "{{brand_name}}拒绝原因：{{reason}}",
  "Internal_Tools_B_jGdF_dNpY": "{{Gas_Station_Name}}的{{Bill_Periods}}下的账单已经推送到{{brand_name}}加油了，账单金额为{{Bill_Amount}}。为确保你能按时收到款项，请尽快确认。",
  "Internal_Tools_B_yzcd_HgnA": "进行中",
  "GDriver_B_RWAU_ZILl": "用户条款",
  "Internal_Tools_B_IYOZ_iwAq": "操作时间",
  "Internal_Tools_B_FKdd_ahtc": "此借记凭证是由{{brand_name}}自动生成的。",
  "Internal_Tools_B_Dlhh_BgJZ": "下载明细对账单至你的邮箱",
  "GDriver_0714_lkkl_OJoY": "评论中最常提及的问题",
  "GDriver_0714_YIVT_ofZZ": "评分越高，油站流量越高",
  "Internal_Tools_B_EGqI_BLrf": "审批记录",
  "Internal_Tools_2_NGLr_hhOD": "移动端暂不支持查看功能，请在PC端操作",
  "Internal_Tools_B_NVMK_FtoH": "油站",
  "Internal_Tools_B_etLT_XTcj": "（油站调整）",
  "GDriver_B_eSPa_nCyq": "{{Page_num}}/页",
  "GDriver_Rate_xJny_zMFD": "暂无历史账单数据",
  "GDriver_0714_oPVR_DxsH": "1星评价中最多的标签",
  "Internal_Tools_B_zluz_RSQE": "{{brand_name}}加油项目",
  "GDriver_0714_Wiqi_rsXT": "提升方向",
  "Internal_Tools_B_IRRc_hZIm": "无效",
  "Internal_Tools_B_hRqn_QiwT": "账单信息",
  "Internal_Tools_3_thwC_VgKl": "在确认之前需滚动查看所有数据",
  "GDriver_0714_QOxf_sbuG": "确认",
  "Internal_Tools_B_BRqr_VajR": "账单已被调整项",
  "Internal_Tools_3_Cdzx_KDff": "周一到周五8:00-18:00",
  "Internal_Tools_3_AUkL_uYJd": "第二步：上传模版文件",
  "GDriver_B_VMvB_MrxF": "日期",
  "Internal_Tools_B_ZNba_eOJt": "（最多展示5条记录）",
  "Internal_Tools_B_WZtb_VmSM": "序号",
  "Internal_Tools_3_QEFE_kxrV": "{{number}}个油品的折后价超过了原价的25%，请再次确认",
  "GDriver_B_nwAp_Bahp": "账号不存在，请更换账号",
  "GDriver_0714_hIJz_Enis": "中性数量",
  "Internal_Tools_B_aTmx_JssU": "{{brand_name}}审核",
  "Internal_Tools_B_SidT_WnWJ": "确认",
  "GDriver_Rate_viTB_cjDd": "注释",
  "Internal_Tools_2_mxFS_VTNj": "液体类燃料单位为升，气体类燃料单位为立方米。",
  "Internal_Tools_B_ZURF_RCND": "请确认是否保存此次油站折扣调整？保存后新的折扣将立即生效。",
  "GDriver_0714_yTiI_GIeu": "用户端界面展示",
  "Internal_Tools_B_tPhY_EMCr": "账单ID",
  "GDriver_Rate_mEjS_xsaH": "支付金额",
  "Internal_Tools_3_eUjQ_yIOl": "使用模版导入折扣",
  "Internal_Tools_B_OLQx_vawS": "代表商品是否在{{brand_name}}加油中对用户展示",
  "Internal_Tools_B_ZHCN_sXeT": "取消",
  "GDriver_B_qyne_lALc": "用户名称",
  "Internal_Tools_B_tILQ_yJAG": "取消",
  "Internal_Tools_2_lyyB_vPzq": "你对金额的调整（{{bill_amount}}调整为{{bill_adjusted_amount}}）被{{brand_name}}驳回了，请按照拒绝原因调整后再发起确认。",
  "Internal_Tools_B_RNhD_qhCK": "对账结算",
  "Internal_Tools_B_GEJX_hrvH": "请输入下架原因",
  "Internal_Tools_B_gDNW_jILR": "{{brand_name}}平台",
  "Internal_Tools_2_YPte_IwOE": "气体类",
  "Internal_Tools_2_aeNy_MYVh": "月",
  "Internal_Tools_2_Pafp_fpyb": "请上传订单细节或其他文件来证明你的金额调整是合理的。",
  "Internal_Tools_3_hDav_blKk": "下载",
  "GDriver_0714_geGf_VDLP": "总数量",
  "Internal_Tools_B_ooUz_fFmX": "操作",
  "GDriver_0714_vWAe_hjDV": "评价标签分布情况",
  "Internal_Tools_2_RxEZ_ESeX": "请输入期望调整后结算金额",
  "Internal_Tools_B_GzFj_Nlnu": "油站调整金额",
  "Internal_Tools_B_qtns_OWdE": "数量",
  "Internal_Tools_B_pLXk_EZcF": "此价格仅为预估价，用户实际折后价会经{{brand_name}}平台调整后上下波动",
  "GDriver_B_tuUz_ZGks": "上周",
  "GDriver_B_QaJz_nHMx": "对账单",
  "Internal_Tools_B_btqY_oyra": "折扣修改记录",
  "Internal_Tools_2_QKQx_ephy": "手机查看",
  "Internal_Tools_4_fhfu_QNpo": "请上传xlsx格式的文件，大小不超过10MB",
  "GDriver_Rate_pKeD_TLlw": "{{Platform_name}}优惠",
  "Internal_Tools_B_rJTV_GFwt": "编辑",
  "Internal_Tools_B_oVBD_xPFJ": "下架",
  "Internal_Tools_2_ANJX_viUn": "折后总额",
  "Internal_Tools_2_Yexl_qwtW": "调整{{num}}笔订单",
  "Internal_Tools_B_XADb_rGKq": "状态",
  "Internal_Tools_B_FcHg_Nkhf": "{{brand_name}}平台",
  "Internal_Tools_B_jMpQ_MhBZ": "最近更新时间：{{time}}",
  "Internal_Tools_B_vETe_JGNb": "固定金额折扣",
  "Internal_Tools_B_ZToB_JbPm": "发送",
  "GDriver_B_BJTU_VFFp": "所选条件下，所有加油订单折扣后总金额",
  "Internal_Tools_B_XbZk_Lagw": "拒绝项：",
  "Internal_Tools_B_atoO_Ssnn": "编辑",
  "GDriver_B_SWsZ_SxEV": "折扣总额={{Brand_Name}}折扣+油站折扣",
  "GDriver_B_LRmo_qQTO": "{{Brand_Name}}折扣",
  "GDriver_0714_ybdp_kBfR": "评分数量",
  "GDriver_B_MyJy_Qfir": "折扣后总额",
  "Internal_Tools_2_uYtG_HGQZ": "选择时间",
  "GDriver_B_OZRC_vJMU": "退出登录",
  "Internal_Tools_2_vYnH_dgVv": "你被{{brand_name}}驳回了，请按照拒绝原因调整后再发起确认。",
  "Internal_Tools_2_ANMs_tYaS": "六月",
  "Internal_Tools_B_qOau_cxQf": "订单报表",
  "GDriver_0714_HBtB_NHqD": "展开全部"
}